import React from 'react';
import styles from './ErrorMessageDisplay.module.css';

interface ErrorMessageDisplayProps {
  message: string;
  type?: 'error' | 'warning' | 'info'; // Added 'info' for more flexibility
  className?: string;
}

// Simple SVG icons for demonstration. Replace with actual SVG components or an icon library if available.
const ErrorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
  </svg>
);

const WarningIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
  </svg>
);

const InfoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
  </svg>
);

const ErrorMessageDisplay: React.FC<ErrorMessageDisplayProps> = ({
  message,
  type = 'error',
  className = '',
}) => {
  const getIcon = () => {
    switch (type) {
      case 'warning':
        return <WarningIcon />;
      case 'info':
        return <InfoIcon />;
      case 'error':
      default:
        return <ErrorIcon />;
    }
  };

  return (
    <div className={`${styles.errorMessageContainer} ${styles[type]} ${className}`}>
      <span className={styles.iconContainer}>{getIcon()}</span>
      <span className={styles.messageText}>{message}</span>
    </div>
  );
};

export default ErrorMessageDisplay; 